
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
XTable,
FlexboxItem
},
methods: {
clear () {
this.search_name = ''
this.queryResult = {Data: [], TotalPage: 0}
},
showDesc (countryData, companyChData, companyENData) {
this.$router.push({name: 'HandBookAntiDumpingCompanyDetail', query: {p_code: this.$route.query.p_code, p_name: this.$route.query.p_name, country: countryData, company_ch: companyChData, company_en: companyENData}})
},
async doQuery () {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/HandBoodkAntiDumping/Detail', {params: {p_code: this.$route.query.p_code, p_name: this.$route.query.p_name, search_name: this.search_name}})
this.currentItem = queryPromise.data
this.$vux.loading.hide()
}
},
data () {
return {
currentItem: null,
search_name: ''
}
},
async activated () {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/HandBoodkAntiDumping/Detail', {params: {p_code: this.$route.query.p_code, p_name: this.$route.query.p_name, search_name: this.search_name}})
this.currentItem = queryPromise.data
this.$vux.loading.hide()
}
}



// WEBPACK FOOTER //
// ./src/components/HandBookAntiDumpingDetail.vue